module.exports = __webpack_public_path__ + "img/Vision&Mission.5eab6308.png";